import React, { useEffect, useRef } from 'react';
import '../styles/fonts.css';
import Sidebar from '../components/Sidebar.jsx';

const Software = () => {
	const timelineRef = useRef(null);

	//let EggAnalyzer = 'https://static.igem.wiki/teams/5066/software/egg-analyzer.png';
	let timelineImg =
		'https://static.igem.wiki/teams/5066/software/swsample.png';
	let coverPic = 'https://static.igem.wiki/teams/5066/global/bgpic.png';
	let mosquitoMove =
		'https://static.igem.wiki/teams/5066/home/mosquito-flying.gif';
	let Bite = 'https://static.igem.wiki/teams/5066/home/mosquito-bites.png';
	let SampleCode =
		'https://static.igem.wiki/teams/5066/software/codesample.png';

	let sections = [
		{ id: 's1', name: 'Starting from Zero' },
		{ id: 's2', name: 'Coding Team Wiki' },
	];

	useEffect(() => {
		const handleScroll = () => {
			const timeline = timelineRef.current;
			const timelineItems = timeline.querySelectorAll('.timeline-item');

			timelineItems.forEach((item) => {
				const rect = item.getBoundingClientRect();
				if (rect.top <= window.innerHeight * 0.8) {
					item.classList.add('visible');
				} else {
					item.classList.remove('visible');
				}
			});
		};

		window.addEventListener('scroll', handleScroll);

		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	return (
		<div>
			<div className='relative bg-[#d9eaf0]'>
				<img
					src={coverPic}
					alt='softwarePic'
					className='w-full h-auto'
				/>
				<div
					style={{ fontFamily: 'MyCustomFont, sans-serif' }}
					className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center text-[#be5169] font-bold text-4xl md:text-7xl z-10'
				>
					{'Software'.split('').map((letter, index) => (
						<span
							key={index}
							className='inline-block opacity-0 animate-fade-in'
							style={{
								animationDelay: `${index * 0.1}s`,
								textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
							}}
						>
							{letter}
						</span>
					))}
				</div>

				<img
					src={mosquitoMove}
					alt='smallPic'
					className='absolute w-48 h-48 mosquito-animation'
				/>

				<img
					src={Bite}
					alt='newSmallPic1'
					className='absolute w-24 h-24 opacity-0 new-small-pic1'
				/>

				<img
					src={Bite}
					alt='newSmallPic2'
					className='absolute w-24 h-24 opacity-0 new-small-pic2'
				/>
			</div>

			<style jsx>{`
				@keyframes fadeIn {
					from {
						opacity: 0;
						transform: translateY(20px);
					}
					to {
						opacity: 1;
						transform: translateY(0);
					}
				}

				.animate-fade-in {
					animation: fadeIn 0.5s ease forwards;
				}

				@keyframes mosquitoRandomFlying {
					0%,
					100% {
						transform: translate(0, 0) rotate(0deg);
					}
					10% {
						transform: translate(100px, 50px) rotate(20deg);
					}
					20% {
						transform: translate(-150px, 80px) rotate(-15deg);
					}
					/* more keyframes */
				}

				.mosquito-animation {
					animation: mosquitoRandomFlying 20s ease-in-out infinite;
					top: 20%;
					left: 5%;
					z-index: 5;
				}

				@keyframes smallPicFadeIn {
					from {
						opacity: 0;
					}
					to {
						opacity: 1;
					}
				}

				.new-small-pic1 {
					top: 65%;
					left: 50%;
					animation: smallPicFadeIn 2s ease forwards 4s;
				}

				.new-small-pic2 {
					top: 75%;
					left: 10%;
					animation: smallPicFadeIn 2s ease forwards 8s;
				}

				/* Timeline animations */
				.timeline-item {
					opacity: 0;
					transform: translateY(50px);
					transition: opacity 0.6s ease, transform 0.6s ease;
				}

				.timeline-item.visible {
					opacity: 1;
					transform: translateY(0);
				}
			`}</style>

			<div className='flex flex-col md:flex-row bg-gradient-to-b from-[#d9eaf0] via-[#e8f3f7] to-[#feedfb]'>
				<Sidebar sections={sections} />

				<div className='w-full md:w-9/10 p-4 md:p-[80px] space-y-8 md:space-y-16 mx-[5px] my-[10px] rounded-2xl bg-[#fffdf2] shadow-[-2px_4px_8px_-2px_rgba(0,0,0,0.4)]'>

					<div className='pb-12'>
						<section id='s1'>
							<div className='absolute -left-24 bg-[#C94C67] w-20 h-7 shadow-md'>
								<span className='text-gray-800 font-bold'></span>
							</div>
							<h2 className='text-2xl md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
								Starting from Zero
							</h2>
							<p className='mt-4 text-gray-700 font-bold leading-relaxed'>
								Team members: Claire, Terrence, Anabelle, and
								Shaun
							</p>
							<p className='mt-2 text-gray-700 leading-relaxed'>
								Our passion for coding was ignited during our
								time in iGEM. With no prior knowledge of coding
								or website development, we started with weekly
								workshops on the basics of programming languages
								like Python, HTML, and CSS. Dedicating ourselves
								to learning coding and UI design throughout the
								initial few months, we were able to bypass
								numerous challenges under the pressure of tight
								deadlines. Racing against time, we were able to
								develop an egg-counting picture analyzer,
								collaborate with Drylab on the epidemiological
								model, and successfully build our team wiki,
								showcasing our achievements and impact on our
								community.
							</p>

							<p className='mt-5 text-gray-700 leading-relaxed'>
								The egg-counting analyzer assisted Wetlab with
								their functional assays through image analysis
								with OpenCV Analysis, locating the exact
								location of mosquito larvae. Further information
								can be found in our Mosquito Egg Counter page.
							</p>
							<p className='mt-5 text-gray-700 leading-relaxed'>
								The collaboration with Drylab allowed us to
								develop our epidemiological model— an
								interactive model showcasing the dynamics
								between larvae, adult mosquitoes, and human
								population in the cross-transmission process.
								Further information can be found in our Software
								X Drylab Model page.
							</p>
							<p className='mt-5 text-gray-700 leading-relaxed'>
								One of the many challenges throughout our coding
								journey was time management. The constant
								content updates from other sub-teams made it
								quite difficult to keep up. Our workflow was
								repeatedly interrupted due to the myriad of
								changes. Additionally, the towering workload
								complicated our work distribution. Therefore, we
								used Trello– a tool that manages our project
								workload and tracks tasks, which allowed us to
								be on top of deadlines and implement our team
								wiki on time.
							</p>
							<p className='mt-5 text-gray-700 leading-relaxed'>
								Moreover, we collaborated with Wetlab when
								developing an egg-counting picture analyzer. As
								we are students joined together from schools all
								over Taiwan, another challenge has arisen—
								miscommunication. This complicated our ability
								to efficiently develop an accurate egg-counting
								picture analyzer. To solve this, we dedicated
								our weekends at GEMS-Academy, effectively
								communicating with each other face-to-face,
								which helped mitigate errors.
							</p>
							<p className='mt-5 text-gray-700 leading-relaxed'>
								Furthermore, in our final phase of this iGEM
								journey, our main job of coding the team wiki—
								something we can all look back on and be proud
								of— faced a seemingly small yet significant
								problem: bugs. Due to the difference in coding
								styles, our codebase became increasingly
								difficult to locate bugs. With the help of every
								member of our project, all the members helped
								locate bugs and listed them in a spreadsheet,
								allowing us to efficiently fix the bugs.
							</p>
							<p className='mt-5 text-gray-700 leading-relaxed'>
								This year, we have placed a spotlight on our
								software development projects to showcase how
								our work enhances collaboration for GEMS-Taiwan
								2024. Hopefully, our models can benefit and
								inspire future iGEM teams.
							</p>
							<p className='pl-8 pt-12 font-bold text-xl text-[#C94C67]'>
								Timeline | Progress
							</p>
							<br />

							<ol
								ref={timelineRef}
								className='relative border-l-2 border-[#C94C67] ml-6'
							>
								<li className='timeline-item mb-10 ms-4'>
									<div className='absolute w-4 h-4 bg-[#C94C67] rounded-full -left-[25.2px] top-1.5 border border-white'></div>
									<time className='mb-1 text-sm font-normal leading-none text-gray-400'>
										May
									</time>
									<h3 className='text-lg font-semibold text-gray-900'>
										React Framework, learning UI, and
										planning visual style
									</h3>
									<p className='mb-4 text-base font-normal text-gray-500'>
										After collecting experimental data from
										the sub-teams, we began to brainstorm
										the style and layout for the homepage
										and other pages on the Team Wiki.
									</p>
									<img
										src={timelineImg}
										alt='sw'
										width='400px'
									/>
								</li>
								<li className='timeline-item mb-10 ms-4'>
									<div className='absolute w-4 h-4 bg-[#C94C67] rounded-full -left-[25.2px] top-1.5 border border-white'></div>
									<time className='mb-1 text-sm font-normal leading-none text-gray-400'>
										June
									</time>
									<h3 className='text-lg font-semibold text-gray-900'>
										Worked with Art Team to decide the
										layout for homepage and Team Wiki pages.
									</h3>
									<p className='text-base font-normal text-gray-500'>
										All of the pages and components are
										first designed in Figma and we will keep
										on editing our figma design in the
										upcoming months.
									</p>
								</li>
								<li className='timeline-item mb-10 ms-4'>
									<div className='absolute w-4 h-4 bg-[#C94C67] rounded-full -left-[25.2px] top-1.5 border border-white'></div>
									<time className='mb-1 text-sm font-normal leading-none text-gray-400'>
										July
									</time>
									<h3 className='text-lg font-semibold text-gray-900'>
										Collected more materials from sub-teams.
										Worked on UI designs & started coding
										using HTML, CSS, and Javascript with
										React Framework.
									</h3>
									<p className='text-base font-normal text-gray-500'>
										We used bootstrap and tailwind css for
										our style, which is easier than opening
										another css file to code.
									</p>
								</li>
								<li className='timeline-item mb-10 ms-4'>
									<div className='absolute w-4 h-4 bg-[#C94C67] rounded-full -left-[25.2px] top-1.5 border border-white'></div>
									<time className='mb-1 text-sm font-normal leading-none text-gray-400'>
										August
									</time>
									<h3 className='text-lg font-semibold text-gray-900'>
										We started coding using React and
										tailwind css
									</h3>
									<p className='text-base font-normal text-gray-500'>
										We started from using a private
										repository in gitlab to ensure our
										privacy.
										<br />
										<span className='italic font-bold'>
											Together, our team made 242 commits
											to gitlab in this month.
										</span>
									</p>
								</li>
								<li className='timeline-item mb-10 ms-4'>
									<div className='absolute w-4 h-4 bg-[#C94C67] rounded-full -left-[25.2px] top-1.5 border border-white'></div>
									<time className='mb-1 text-sm font-normal leading-none text-gray-400'>
										September
									</time>
									<h3 className='text-lg font-semibold text-gray-900'>
										We began adding styles and animations to
										our wiki.
									</h3>
									<p className='text-base font-normal text-gray-500'>
										Art team also drew more gifs and
										pictures for our wiki.
									</p>
								</li>
								<li className='timeline-item ms-4'>
									<div className='absolute w-4 h-4 bg-[#C94C67] rounded-full -left-[25.2px] top-1.5 border border-white'></div>
									<time className='mb-1 text-sm font-normal leading-none text-gray-400'>
										October 2nd
									</time>
									<h3 className='text-lg font-bold text-red-500'>
										Wiki Freeze
									</h3>
									<p className='text-base font-normal text-gray-500'>
										We work very hard by successfully
										pushing all the content to the wiki.
										<br />
										<span className='italic font-bold'>
											Together, we made [542] commits to
											gitlab overall.
										</span>
									</p>
								</li>
							</ol>
						</section>
					</div>

					<div className='pb-12'>
						<section id='s2'>
							<div className='absolute -left-24 bg-[#C94C67] w-20 h-7 shadow-md'>
								<span className='text-gray-800 font-bold'></span>
							</div>
							<h2 className='text-2xl md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
								Coding Team Wiki
							</h2>
							<p className='mt-2 text-gray-700 leading-relaxed'>
								We began learning coding and UI design in early
								May, starting from scratch. Initially, we faced
								many challenges like having to debug our
								mistakes or not being familiar enough with our
								code, but through perseverance, we gradually
								improved our skills. Eventually, we successfully
								completed the development of our Team Wiki
								website.
							</p>
							<br />
							<p className='mt-2 text-gray-700 leading-relaxed'>
								To successfully code our website, we used
								<p1 className='italic  text-gray-700 hover:text-gray-400'>
									{' '}
									Visual Studio Code{' '}
								</p1>
								to write the code. Our wiki is based on{' '}
								<p1 className='italic text-gray-700 hover:text-gray-400'>
									React Framework
								</p1>
								, which is a popular JavaScript library,
								primarily used for building user interfaces,
								particularly single-page applications (SPAs). To
								fasten our coding without opening another css
								file, we used{' '}
								<p1 className='italic text-gray-700 hover:text-gray-400'>
									Tailwind CSS.
								</p1>
							</p>
							<p className='mt-2 text-gray-700 leading-relaxed'>
								Sample of combing React Framework with Tailwind
								css:{' '}
							</p>
							<img
								src={SampleCode}
								alt='sample'
								className='w-144 h-auto rounded-xl'
							></img>
						</section>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Software;
